<template>
  <div class="flex operation_area">
    <el-select v-model="fromLanguage" placeholder="请选择" filterable clearable>
      <el-option
        v-for="item in left"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <div class="icon flex_default_center">
      <i class="el-icon-sort" @click="exchange" ></i>
    </div>
    <el-select v-model="toLanguage" placeholder="请选择" filterable clearable>
      <el-option
        v-for="item in right"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-button
      :loading="load"
      style="margin-left:4px;height:36px;line-height:36px;padding:0 15px!important"
      type="primary"
      @click="translateTextCus"
      >翻译</el-button
    >
  </div>
</template>

<script>
import { translate } from "@/api/fy";

export default {
  name: "translate",
  props: {
    content: {
      type: String,
      default: ""
    },
    field: {
      type: String,
      default: ""
    },
    from: {
      type: String,
      default: "en"
    },
    to: {
      type: String,
      default: "zh-CHS"
    }
  },
  data() {
    return {
      left: [
        {
          value: "zh-CHS",
          label: "中文"
        },
        {
          value: "en",
          label: "英语"
        },
        {
          value: "ko",
          label: "韩语"
        },
        {
          value: "fa",
          label: "波斯语"
        },
        {
          value: "ru",
          label: "俄语"
        },
        {
          value: "es",
          label: "西班牙语"
        },
        {
          value: "tr",
          label: "土耳其语"
        },
        {
          value: "it",
          label: "意大利语"
        },
        {
          value: "vi",
          label: "越南语"
        }
      ],
      right: [
        {
          value: "zh-CHS",
          label: "中文"
        },
        {
          value: "en",
          label: "英语"
        },
        {
          value: "ko",
          label: "韩语"
        },
        {
          value: "fa",
          label: "波斯语"
        },
        {
          value: "ru",
          label: "俄语"
        },
        {
          value: "es",
          label: "西班牙语"
        },
        {
          value: "tr",
          label: "土耳其语"
        },
        {
          value: "it",
          label: "意大利语"
        },
        {
          value: "vi",
          label: "越南语"
        }
      ],
      load: false,
      fromLanguage: "",
      toLanguage: ""
    };
  },
  mounted() {
    this.fromLanguage = this.from;
    this.toLanguage = this.to;
  },
  methods: {
    //点击翻译
    async translateTextCus() {
      try {
        this.load = true;
        let query = {
          data: {
            text: this.content,
            sourceLanguage: this.fromLanguage,
            targetLanguage: this.toLanguage
          }
        };
        const res = await translate(query);
        if (res.status == 0) {
          this.$emit("getTranslateVal", this.field, res.data);
        } else {
          this.$DonMessage.warning("第三方接口反馈出错，请点击翻译按钮重试");
        }
        this.load = false;
      } catch (error) {
        this.load = false;
      }
    },
    exchange(){
      let t = this.toLanguage
      this.toLanguage = this.fromLanguage
      this.fromLanguage = t
    },
  }
};
</script>

<style lang="scss" scoped>
.operation_area {
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  ::v-deep .el-input {
    width: 100px !important;
  }
  .icon {
    flex-shrink: 0;
    transform: rotate(90deg);
  }
}
</style>
